import React, { useState, useEffect } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { isFormValid, onGetErrorMessage, onGetFormData, onSetErrorsToForm, updateAuthorizationHeader } from '../../../../../shared/utility'
import { useStyles } from './styles'
import { catalogs } from '../../../../../texts/esp/catalogs'
import InputForm from '../../../../../components/Forms/InputForm'
import SimpleModal from '../../../../../components/Modals/SimpleModal'
import RoundedButton from '../../../../../components/Actions/RoundedButton'
import InputSelectForm from '../../../../../components/Forms/InputSelectForm'
import { private_server } from '../../../../../config'


const PasswordModal = props => {

    const { open, onClose, origin, actions, onRequestUsers, history } = props

    const classes = useStyles()
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(' ')

    useEffect(() => {
        if (!open) {
            setForm(JSON.parse(JSON.stringify(formData)))
            setError(''); setLoading(false);
        }
    }, [open])


    const onChange = (data) => {
        let temp = { ...form }
        const id = data.config.id
        temp[id] = { ...data }
        //if(id === 'password') temp['passwordConfirmation'].value2 = temp[id].value
        setForm(temp)
    }

    const onSubmit = async () => {
        const errors = isFormValid(form)
        /// Check if the form is valid
        if(errors && errors.length){
            const new_form = onSetErrorsToForm(form, errors)
            setForm(new_form)
            return
        }

        //Extract data
        let data2send = onGetFormData(form)
        console.log(data2send)
        //delete data2send.passwordConfirmation
        setLoading(true)
        try {
            updateAuthorizationHeader(private_server)
            await private_server.post(`/user/me/passwordchange`, data2send)
            await actions.onRefreshData()
            actions.onUpdateModal('change_password', false)
        } catch (error) {
            console.log(error)
            setError(onGetErrorMessage(error))
            setLoading(false)
        }

    }

    return (
        <SimpleModal open={open} onClose={onClose} maxWidth='sm'>
            <div >
                <Typography variant='h6' style={{ fontWeight: 600 }}>Cambio de contraseña</Typography>
                <Typography variant='body1' color='textSecondary'>Por favor ingresa los datos solicitados</Typography>
                <div className={classes.form}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <InputForm data={form.previous_password} onChange={onChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputForm data={form.new_password} onChange={onChange} />
                        </Grid>
                    </Grid>
                </div>
                <div style={{width:'100%', textAlign:'center'}}>
                    <RoundedButton color='primary'  onClick={onSubmit} loading={loading}>
                        Actualizar
                    </RoundedButton>
                    <Typography color='error' align='center'>{error}</Typography>
                </div>
            </div>
        </SimpleModal>
    )
}

export default PasswordModal


const formData = {
    previous_password: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'previous_password',
            type: 'password',
            fullWidth: true,
            label: 'Contraseña anterior',
            helperText: 'Debe contener 6 a 20 caracteres',
            //autoComplete:'new-password'
        },
        rules: {
            type: 'distance',
            min:6, max:20
        }
    },
    new_password: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'new_password',
            type: 'password',
            fullWidth: true,
            label: 'Nueva contraseña',
            helperText: 'Debe contener 6 a 20 caracteres'
        },
        rules: {
            type: 'distance',
            min:6, max:20
        }
    },
}